import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=5a18128f"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownViewer.vue?vue&type=style&index=0&id=5a18128f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports